export const notfound = {
  'seo.title': '404 — Page Not Found | Sofia & Elena',
  'seo.description': 'The page you are looking for could not be found.',
  'seo.keywords': '404, page not found',
  'title': 'Page Not Found',
  'description': 'The page you are looking for does not exist or has been moved.',
  'button': 'Back to Home',
  'buttonAria': 'Go back to the home page',
};